import { subscribeWithIDAPI } from './api';
import isEmpty from 'lodash/isEmpty';

/*
 * Note: 
 * only invoked on subscriber.subscriberActive() from Oauth Session Flow
 * will only happen when the data from the response of  subscriberActive() API Call is NOT EMPTY.
 */

async function subscribeWithId (params) {
    const env = this.env;
    const appStore = this.env.appStore;
    const statesStore = this.env.uiStatesStore;
    const apiKey = appStore.widgetSettings.apikey;
    const schedulesStore = this.env.schedulesStore;

    if (isEmpty(params.calendarIds)) {
        params.calendarIds = schedulesStore.allScheduleIds;
    }

    if (appStore.skip_schedule_selection) {
      params.calendarIds = [];
    }
 
    if (env.page?.params?.subscriber_reference) {
        params.reference = env.page?.params?.subscriber_reference;
    }

    const body = {
        ...statesStore.subscribersParams,
        ...params,
        application: statesStore.selectedCalendar.toLowerCase(),
    };

    this.cleanPayload({
        body,
        appStore,
        env,
        schedulesStore,
    });

    if (params.id) body.id = params.id;

    const res = await subscribeWithIDAPI({
        apiKey,
        subscriberId: params.id,
        body,
        widgetId: appStore.widget.id,
        traceId: env.traceId,
        store: this,
    });

    // process res..
    console.log('subscribe () Res: -> ', res);
    // immediately make teh complete subscription call
    await this.completeSubscription({
        id: params.id,
        user_type: 'returning',
        calendar_type: statesStore.selectedCalendar.toLowerCase(),
        calendar_ids: params.calendarIds,
    });
}

export default subscribeWithId;